export const LOAD_DOCUMENT_SCORING_HISTORY_STARTED = "LOAD_DOCUMENT_SCORING_HISTORY_STARTED";
export const LOAD_DOCUMENT_SCORING_HISTORY_SESSION_SUCCESS = "LOAD_DOCUMENT_SCORING_HISTORY_SESSION_SUCCESS";
export const LOAD_DOCUMENT_SCORING_HISTORY_SESSION_GRIDS_SUCCESS =
  "LOAD_DOCUMENT_SCORING_HISTORY_SESSION_GRIDS_SUCCESS";
export const UPDATE_DOCUMENT_SCORING_KNOCKOUT_CRITERIA_HISTORY_SUCCESS =
  "UPDATE_DOCUMENT_SCORING_KNOCKOUT_CRITERIA_HISTORY_SUCCESS";
export const UPDATE_DOCUMENT_SCORING_CATEGORY_HISTORY_SUCCESS = "UPDATE_DOCUMENT_SCORING_CATEGORY_HISTORY_SUCCESS";
